import { render, staticRenderFns } from "./PatientZero.vue?vue&type=template&id=085bb27a"
import script from "./PatientZero.vue?vue&type=script&lang=js"
export * from "./PatientZero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports